import React, { useState } from 'react';
import { Checkbox } from '../../../components/ui/Checkbox';
import Icon from '../../../components/AppIcon';

const AdvancedSection = ({ 
  formData, 
  handleCheckboxChange 
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="card">
      <div 
        className="flex items-center justify-between cursor-pointer"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <div className="flex items-center gap-3">
          <div className="flex items-center justify-center w-10 h-10 md:w-12 md:h-12 rounded-xl bg-accent-pink/20 glow-subtle">
            <Icon name="Wrench" size={20} color="var(--color-accent-pink)" />
          </div>
          <div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground">Advanced / Power User</h2>
            <p className="text-xs md:text-sm text-muted-foreground font-caption">
              Beta features and developer tools
            </p>
          </div>
        </div>
        <Icon 
          name={isExpanded ? "ChevronUp" : "ChevronDown"} 
          size={24} 
          color="var(--color-muted-foreground)" 
        />
      </div>

      {isExpanded && (
        <div className="mt-6 md:mt-8 space-y-6 md:space-y-8">
          <div>
            <h3 className="text-base md:text-lg font-semibold text-foreground mb-4">Beta Features</h3>
            <div className="p-4 rounded-lg bg-warning/10 border border-warning/20 mb-4">
              <div className="flex items-start gap-3">
                <Icon name="AlertTriangle" size={20} color="var(--color-warning)" className="flex-shrink-0 mt-0.5" />
                <div>
                  <p className="text-sm font-medium text-foreground mb-1">Beta Warning</p>
                  <p className="text-xs text-muted-foreground">
                    Beta features may be unstable and are subject to change. Use at your own risk.
                  </p>
                </div>
              </div>
            </div>
            <div className="space-y-3">
              <Checkbox
                label="Opt into beta features"
                description="Enable access to experimental features"
                checked={formData?.enableBetaFeatures}
                onChange={(e) => handleCheckboxChange('enableBetaFeatures', e?.target?.checked)}
              />
              {formData?.enableBetaFeatures && (
                <div className="ml-6 space-y-3 border-l-2 border-accent-pink/20 pl-4">
                  <Checkbox
                    label="AI-powered schedule optimization"
                    checked={formData?.betaAiSchedule}
                    onChange={(e) => handleCheckboxChange('betaAiSchedule', e?.target?.checked)}
                  />
                  <Checkbox
                    label="Advanced pay projections"
                    checked={formData?.betaPayProjections}
                    onChange={(e) => handleCheckboxChange('betaPayProjections', e?.target?.checked)}
                  />
                  <Checkbox
                    label="Crew trading marketplace"
                    checked={formData?.betaCrewTrading}
                    onChange={(e) => handleCheckboxChange('betaCrewTrading', e?.target?.checked)}
                  />
                  <Checkbox
                    label="Historical data analytics"
                    checked={formData?.betaAnalytics}
                    onChange={(e) => handleCheckboxChange('betaAnalytics', e?.target?.checked)}
                  />
                </div>
              )}
            </div>
          </div>

          <div className="h-px bg-accent-pink/20"></div>

          <div>
            <h3 className="text-base md:text-lg font-semibold text-foreground mb-4">Developer Mode</h3>
            <Checkbox
              label="Enable developer mode"
              description="Show API logs, console output, and performance metrics"
              checked={formData?.enableDeveloperMode}
              onChange={(e) => handleCheckboxChange('enableDeveloperMode', e?.target?.checked)}
            />
            {formData?.enableDeveloperMode && (
              <div className="mt-4 p-4 rounded-lg bg-tertiary border border-accent-pink/20">
                <p className="text-xs text-muted-foreground mb-2">Developer tools enabled:</p>
                <ul className="text-xs text-muted-foreground space-y-1 list-disc list-inside">
                  <li>API request logs</li>
                  <li>Console logs visible</li>
                  <li>Network traffic monitor</li>
                  <li>Database query times</li>
                  <li>Cache status indicators</li>
                </ul>
              </div>
            )}
          </div>

          <div className="h-px bg-accent-pink/20"></div>

          <div>
            <h3 className="text-base md:text-lg font-semibold text-foreground mb-4">Experimental UI</h3>
            <Checkbox
              label="Use experimental layouts"
              description="Try new UI designs and components (A/B testing)"
              checked={formData?.experimentalUi}
              onChange={(e) => handleCheckboxChange('experimentalUi', e?.target?.checked)}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default AdvancedSection;